import { previewFile, uploadFile, uploadFileLarge } from '@elecmap/api/src/cad/file'
import type { UploadFileResponse } from '@elecmap/api/src/cad/file.d'
import { notificationWarn } from './notification'

let textRuler: HTMLDivElement = null!

export function getDomSize(dom: HTMLElement) {
  if (!textRuler) {
    textRuler = document.createElement('div')
    textRuler.style.display = 'inline'
    textRuler.style.position = 'fixed'
    textRuler.style.zIndex = '-99'
    textRuler.style.opacity = '0'
    textRuler.style.whiteSpace = 'pre-wrap'
    document.body.appendChild(textRuler)
  }
  textRuler.style.fontSize = dom.style.fontSize
  textRuler.style.fontFamily = dom.style.fontFamily
  textRuler.style.fontWeight = dom.style.fontWeight
  textRuler.style.fontStyle = dom.style.fontStyle
  textRuler.style.textDecoration = dom.style.textDecoration
  textRuler.style.transform = dom.style.transform
  textRuler.style.lineHeight = dom.style.lineHeight
  textRuler.innerHTML = dom.innerHTML
  return textRuler.getBoundingClientRect()
}

let fileInput: HTMLInputElement = null!
type SelectFileOptions = {
  accept?: string
  /**
   * 单位：mb
   */
  limitSize?: number
  folder?: number
  multiple?: boolean
}

export function selectFile({
  accept = '.jpg,.jpeg,.png',
  limitSize = 3,
  folder,
  multiple = false,
}: SelectFileOptions = {}) {
  fileInput = document.createElement('input')
  fileInput.type = 'file'
  fileInput.multiple = multiple
  fileInput.accept = accept

  return new Promise<UploadFileResponse[]>(resolve => {
    async function onChange(e: any) {
      const file = e.target.files[0]

      if (!file) return

      if (accept === '.jpg,.jpeg,.png') {
        // 验证文件类型
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png']
        if (!validTypes.includes(file.type)) {
          notificationWarn('请选择 JPG、JPEG 或 PNG 格式的图片')
          e.target.value = ''
          return
        }

        // 验证文件大小
        if (file.size > limitSize * 1024 * 1024) {
          notificationWarn('文件大小不能超过 3MB')
          e.target.value = ''
          return
        }
      }

      const data = await uploadFile(e.target.files, folder)
      resolve(data)
    }
    fileInput.addEventListener('change', onChange, { once: true })
    fileInput.click()
  })
}

export function selectFileLarge({
  accept = '.jpg,.jpeg,.png',
  limitSize = 3,
  folder,
  multiple = false,
}: SelectFileOptions = {}) {
  fileInput = document.createElement('input')
  fileInput.type = 'file'
  fileInput.multiple = multiple
  fileInput.accept = accept

  return new Promise<UploadFileResponse[]>(resolve => {
    async function onChange(e: any) {
      const file = e.target.files[0]

      if (!file) return

      if (accept === '.jpg,.jpeg,.png') {
        // 验证文件类型
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png']
        if (!validTypes.includes(file.type)) {
          notificationWarn('请选择 JPG、JPEG 或 PNG 格式的图片')
          e.target.value = ''
          return
        }

        // 验证文件大小
        if (file.size > limitSize * 1024 * 1024) {
          notificationWarn('文件大小不能超过 3MB')
          e.target.value = ''
          return
        }
      }

      const data = await uploadFileLarge(e.target.files, folder)
      resolve(data)
    }
    fileInput.addEventListener('change', onChange, { once: true })
    fileInput.click()
  })
}

export function downloadFile(uuid: string, name: string) {
  const link = document.createElement('a')
  link.href = previewFile(uuid)
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * 暂时实现y轴方向
 */
export function isInViewport(element: HTMLElement | undefined, container: HTMLElement) {
  if (!element) return false
  const rect = element.getBoundingClientRect()
  const containerRect = container.getBoundingClientRect()
  const top = rect.y - containerRect.y
  return top >= 0 && top + rect.height <= containerRect.height
}
